import React, { type JSX } from "react";
import ChatList, { ChatsHeading } from "./ChatList";
import NewChatLink from "./NewChatLink";
import type { ChatTarget, SidebarProject } from "./ChatList";

interface SidebarChatsProps {
  isCollapsed: boolean;
  projects: SidebarProject[];
  projectsLoading: boolean;
  currentProjectId: string | null;
  onStartProject?: () => void;
  onProjectClick?: (projectId: string) => void;
  onOpenSearch: () => void;
  onRename: (target: ChatTarget) => void;
  onDelete: (target: ChatTarget) => void;
}

/** Scrollable chats section: heading, new-chat affordance and the chat list. */
export default function SidebarChats({
  isCollapsed,
  projects,
  projectsLoading,
  currentProjectId,
  onStartProject,
  onProjectClick,
  onOpenSearch,
  onRename,
  onDelete,
}: SidebarChatsProps): JSX.Element {
  return (
    <div className="flex-1 overflow-y-auto overflow-x-hidden py-6 min-h-0">
      <div className="px-4">
        {!isCollapsed && <ChatsHeading onOpenSearch={onOpenSearch} />}

        <NewChatLink isCollapsed={isCollapsed} onStartProject={onStartProject} />

        {/* Chats List - only show when not collapsed */}
        {!isCollapsed && (
          <ChatList
            projects={projects}
            projectsLoading={projectsLoading}
            currentProjectId={currentProjectId}
            onProjectClick={onProjectClick}
            onRename={onRename}
            onDelete={onDelete}
          />
        )}
      </div>
    </div>
  );
}
